import _ from 'lodash'
import { BotCategorizationData, BotConfiguration, BotMetadata } from '@feedyou/schema'

export function isBotSoftDeleted(config: BotConfiguration | BotMetadata) {
  return config.softDeletedAtTimestamp
}

export function isBotHardDeleted(config: BotConfiguration) {
  return config.isHardDeleted
}

export function isBotArchived(config: BotConfiguration | BotMetadata) {
  return !!config.archivedAtTimestamp
}

export const extractCategorizationData = (config: BotConfiguration): BotCategorizationData => {
  return _.pick(config, ['client', 'type', 'category', 'name', 'shortDescription'])
}
